import React from 'react';
import { Header } from './index';
import parse from 'html-react-parser';
import { getPostAuthors } from '../../../../model/author';
import { useWipAuthors } from '../../../../hooks/use-wip-authors';
import SocialLinks from '../social-icons';

const SingleDocumentary = ({
  postData,
  location,
  articleContent,
  socialUrls,
  handleCopyClick,
  isCopied,
}) => {
  const allAuthors = useWipAuthors();

  const {
    // Graph powered
    excerpt,
    tghpwipDocumentarySubtitle: documentarySubtitle,
    tghpwipDocumentaryEpisodes: documentaryEpisodes,
    tghpwipDocumentaryAuthor: documentaryAuthorIds,
    tghpwipDocumentarySponsors: documentarySponsors,
    // Bolted
    postImage,
    issueName,
    validCategories,
  } = postData;

  const documentaryAuthors = getPostAuthors(documentaryAuthorIds, allAuthors);

  return (
    <>
      <Header
        subtitle={documentarySubtitle}
        issueName={issueName}
        postImage={postImage}
        categories={validCategories}
        postAuthors={documentaryAuthors}
        documentaryEpisodes={documentaryEpisodes}
        documentarySponsors={documentarySponsors}
        location={location}
        socialUrls={socialUrls}
        handleCopyClick={handleCopyClick}
        isCopied={isCopied}
      />
      <section className="single-article__content-grid">
        <div className="single-article__content-grid-inner">
          <SocialLinks
            classname="single-article__social-media"
            simpleTwitterShareUrl={socialUrls.simpleTwitterShareUrl}
            simpleMatterShareUrl={socialUrls.simpleMatterShareUrl}
            simpleEmailShareUrl={socialUrls.simpleEmailShareUrl}
            handleCopyClick={handleCopyClick}
            isCopied={isCopied}
          />
          <div className="single-article__excerpt">{parse(excerpt)}</div>
          <aside className="single-article__toc" />
          <article className="single-article__article">{articleContent}</article>
          <aside className="single-article__reference-column" />
        </div>
      </section>
    </>
  );
};

export default SingleDocumentary;
